export default __webpack_public_path__ + "e5815de46d8a643a5bd035ec7a53858e.png";